import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function Icon3DGlasses48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D glasses">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1342 8.77983C12.6545 7.0256 15.3439 6.92967 16.9854 8.57113L18.6583 10.2441C20.2983 11.884 18.3002 14.5329 16.2728 13.4066L14.4619 12.4005L10.553 21H37.447L33.5382 12.4005L31.7272 13.4066C29.6998 14.5329 27.7017 11.884 29.3417 10.2441L31.0147 8.57113C32.6561 6.92967 35.3455 7.0256 36.8658 8.77983L47.7557 21.3451C47.953 21.5727 48.0371 21.8771 47.9848 22.1738L45.1306 38.3476C44.9619 39.3033 44.1315 40 43.161 40H29.7047C28.8595 40 28.1055 39.4686 27.8212 38.6727L24.9417 30.6101C24.6257 29.7252 23.3743 29.7252 23.0583 30.6101L20.1788 38.6727C19.8945 39.4686 19.1405 40 18.2953 40H3.88925C2.87508 40 2.02145 39.2409 1.90295 38.2337L0.00685422 22.1168C-0.0259927 21.8376 0.0601986 21.5575 0.244316 21.3451L11.1342 8.77983ZM39.6439 21H44.81L35.3545 10.0897C34.5943 9.21258 33.2496 9.16461 32.4289 9.98534L30.7559 11.6583L32.5669 10.6522C33.5878 10.085 34.8756 10.5097 35.3589 11.5729L39.6439 21ZM45.8081 23H2.12455L3.88925 38H18.2953L21.1748 29.9374C22.1229 27.2827 25.8771 27.2828 26.8252 29.9374L29.7047 38H43.161L45.8081 23ZM3.18997 21H8.35609L12.6411 11.5729C13.1244 10.5097 14.4122 10.085 15.4331 10.6522L17.2441 11.6583L15.5711 9.98534C14.7504 9.16461 13.4057 9.21258 12.6456 10.0897L3.18997 21Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.2575 25.3301C5.44711 25.12 5.71693 25 6 25H19C19.3258 25 19.6312 25.1587 19.8184 25.4254C20.0056 25.692 20.0512 26.0332 19.9406 26.3396L16.6906 35.3396C16.5475 35.7359 16.1713 36 15.75 36H6.92858C6.41603 36 5.98646 35.6125 5.93386 35.1026L5.00529 26.1026C4.97623 25.821 5.06788 25.5403 5.2575 25.3301ZM7.10849 27L7.83071 34H15.0479L17.5757 27H7.10849Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.7753 25.3684C42.5854 25.1353 42.3007 25 42 25H29C28.6663 25 28.3545 25.1665 28.1689 25.4439C27.9833 25.7213 27.9483 26.073 28.0756 26.3815L31.7899 35.3815C31.9444 35.7558 32.3094 36 32.7143 36H40.1429C40.6172 36 41.0264 35.6667 41.1222 35.2021L42.9794 26.2021C43.0401 25.9076 42.9652 25.6015 42.7753 25.3684ZM40.7726 27L39.3281 34H33.3834L30.4945 27H40.7726Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function Icon3DGlasses24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D glasses">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.68902 4.78797C5.87465 3.30592 8.12125 3.28346 9.33628 4.7415L10.2682 5.85983C10.6218 6.2841 10.5645 6.91467 10.1402 7.26823C9.71591 7.62179 9.08535 7.56447 8.73178 7.14019L7.79984 6.02186C7.39483 5.53585 6.64597 5.54334 6.25075 6.03736L3.08063 10H20.9194L17.7493 6.03736C17.354 5.54334 16.6052 5.53585 16.2002 6.02186L15.2682 7.14019C14.9147 7.56447 14.2841 7.62179 13.8598 7.26823C13.4355 6.91467 13.3782 6.2841 13.7318 5.85983L14.6637 4.7415C15.8788 3.28346 18.1254 3.30592 19.311 4.78797L23.7809 10.3753C23.9513 10.5883 24.0273 10.8618 23.9912 11.1322L23.1069 17.7643C22.9745 18.7579 22.1269 19.5 21.1245 19.5H15.1667C14.3593 19.5 13.6311 19.0145 13.3205 18.2692L12 15.1L10.6795 18.2692C10.369 19.0145 9.64074 19.5 8.83334 19.5H2.87552C1.87312 19.5 1.02555 18.7579 0.893065 17.7643L0.00877665 11.1322C-0.0272791 10.8618 0.0487116 10.5883 0.219136 10.3753L4.68902 4.78797ZM21.8578 12H2.14219L2.87552 17.5H8.83334L10.1539 14.3308C10.8376 12.6898 13.1624 12.6898 13.8462 14.3308L15.1667 17.5H21.1245L21.8578 12Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function Icon3DGlasses16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D glasses">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.69575 2.89004C4.38544 2.20036 5.47204 2.10875 6.26746 2.67324L6.98785 3.18449C7.43824 3.50412 7.54424 4.12835 7.22461 4.57874C6.90498 5.02913 6.28075 5.13514 5.83036 4.8155L5.10996 4.30426L3.41423 6H12.5858L10.8901 4.30426L10.1697 4.8155C9.71928 5.13514 9.09505 5.02913 8.77541 4.57874C8.45578 4.12835 8.56178 3.50412 9.01217 3.18449L9.73257 2.67324C10.528 2.10875 11.6146 2.20036 12.3043 2.89004L15.7071 6.29289C15.9355 6.52125 16.0395 6.84584 15.9864 7.16439L14.9864 13.1644C14.906 13.6466 14.4889 14 14 14H10C9.66566 14 9.35343 13.8329 9.16796 13.5547L8.00001 11.8028L6.83206 13.5547C6.6466 13.8329 6.33437 14 6.00001 14H2.00001C1.51117 14 1.09398 13.6466 1.01362 13.1644L0.0136187 7.16439C-0.0394742 6.84584 0.0645449 6.52125 0.292906 6.29289L3.69575 2.89004ZM13.8196 8H2.18047L2.84714 12H5.46483L7.16796 9.44529C7.35343 9.1671 7.66566 9 8.00001 9C8.33437 9 8.6466 9.1671 8.83206 9.44529L10.5352 12H13.1529L13.8196 8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
